<template>
  <div>
    <nav v-if="isAuthenticated">
      <Navbar />
    </nav>
    <nav v-else>
      <router-view />
    </nav>
  </div>
</template>

<script>
import Navbar from "./Pages/Navbar.vue";
import { mapGetters } from "vuex";
export default {
  components: { Navbar },

  computed: {
    ...mapGetters(["isAuthenticated"]), 
  },
};
</script>

<style>

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}
body {
  background: linear-gradient(135deg, #48010111, #989892, #443c3a) no-repeat;
  background-size: cover; 
  background-attachment: fixed; 
  font-family: 'Poppins', sans-serif;
  color: #333;
 
}

</style>